module.exports = __webpack_public_path__ + "static/media/edit.d37d9400.svg";